import { ArrowUpRight, MessageCircle } from "lucide-react";

const base =
    "inline-flex items-center justify-center gap-2 rounded-full font-semibold text-sm sm:text-base px-7 py-3.5 transition-colors duration-200";

export const PrimaryButton = ({ children, onClick, href, testid, className = "", type = "button" }) => {
    const cls = `${base} bg-brand-orange text-white hover:bg-brand-orange-dark ${className}`;
    if (href) {
        const external = href.startsWith("http");
        return (
            <a
                data-testid={testid}
                href={href}
                className={cls}
                {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
                {children}
                <ArrowUpRight size={18} aria-hidden="true" />
            </a>
        );
    }
    return (
        <button data-testid={testid} type={type} onClick={onClick} className={cls}>
            {children}
            <ArrowUpRight size={18} aria-hidden="true" />
        </button>
    );
};

export const SecondaryButton = ({ children, onClick, href, testid, className = "", dark = false }) => {
    const cls = `${base} border-2 ${
        dark
            ? "border-brand-cream/40 text-brand-paper hover:bg-brand-paper hover:text-brand-brown"
            : "border-brand-brown text-brand-brown hover:bg-brand-brown hover:text-white"
    } ${className}`;
    if (href) {
        const external = href.startsWith("http");
        return (
            <a
                data-testid={testid}
                href={href}
                className={cls}
                {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
            >
                {children}
            </a>
        );
    }
    return (
        <button data-testid={testid} type="button" onClick={onClick} className={cls}>
            {children}
        </button>
    );
};

export const WhatsAppButton = ({ href, testid, dark = false, children = "Start a WhatsApp conversation" }) => (
    <SecondaryButton href={href} testid={testid} dark={dark}>
        <MessageCircle size={18} aria-hidden="true" />
        {children}
    </SecondaryButton>
);
